import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const deviceRoutes: Route = {
    path: 'device',
    data: { title: 'device' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'inventory' },
        {
            path: 'inventory-full',
            loadComponent: () => import('./inventory/inventory.component').then((m) => m.InventoryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Inventory Full' },
        },
        {
            path: 'inventory',
            loadComponent: () =>
                import('./inventory-list/inventory-list.component').then((m) => m.InventoryListComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'inventory' },
        },
        {
            path: 'inventory-sim-history',
            loadComponent: () =>
                import('./inventory-sim-history/inventory-sim-history.component').then((m) => m.InventorySimHistoryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'inventory-sim-history' },
        },
        {
            path: 'inventory-status-history',
            loadComponent: () =>
                import('./inventory-status-history/inventory-status-history.component').then(
                    (m) => m.InventoryStatusHistoryComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'inventory-status-history' },
        },
        {
            path: 'inventory-update',
            loadComponent: () =>
                import('./inventory-update/inventory-update.component').then((m) => m.InventoryUpdateComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'inventory-update' },
        },
        {
            path: 'inventory-images',
            loadComponent: () =>
                import('./inventory-images/inventory-images.component').then((m) => m.InventoryImagesComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'inventory-images' },
        },
        {
            path: 'device-model',
            loadComponent: () => import('./device-model/device-model.component').then((m) => m.DeviceModelComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'device-model' },
        },
        {
            path: 'device-line',
            loadComponent: () => import('./device-line/device-line.component').then((m) => m.DeviceLineComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'device-line' },
        },
        {
            path: 'siminventory',
            loadComponent: () => import('./siminventory/siminventory.component').then((m) => m.SiminventoryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Siminventory' },
        },
        {
            path: 'simprovider',
            loadComponent: () => import('./simprovider/simprovider.component').then((m) => m.SimproviderComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Simprovider' },
        },
        {
            path: 'device-configuration',
            loadComponent: () =>
                import('./device-configuration/device-configuration.component').then((m) => m.DeviceConfigurationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Device configuration' },
        },
        {
            path: 'device-document',
            loadComponent: () =>
                import('./device-document/device-document.component').then((m) => m.DeviceDocumentComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Device document' },
        },
        {
            path: 'device-firmware',
            loadComponent: () =>
                import('./device-firmware/device-firmware.component').then((m) => m.DeviceFirmwareComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Device firmware' },
        },
        {
            path: 'device-generation',
            loadComponent: () =>
                import('./device-generation/device-generation.component').then((m) => m.DeviceGenerationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Device generation' },
        },
        {
            path: 'device-operation-mode',
            loadComponent: () =>
                import('./device-operation-mode/device-operation-mode.component').then((m) => m.DeviceOperationModeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Device operation mode' },
        },
        {
            path: 'device-ownership',
            loadComponent: () =>
                import('./device-ownership/device-ownership.component').then((m) => m.DeviceOwnershipComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Device ownership' },
        },
        {
            path: 'inventory-configuration',
            loadComponent: () =>
                import('./inventory-configuration/inventory-configuration.component').then(
                    (m) => m.InventoryConfigurationComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Inventory configuration' },
        },
        {
            path: 'inventory-plantation',
            loadComponent: () =>
                import('./inventory-plantation/inventory-plantation.component').then((m) => m.InventoryPlantationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Inventory plantation' },
        },
        {
            path: 'inventory-enterprise',
            loadComponent: () =>
                import('./inventory-enterprise/inventory-enterprise.component').then((m) => m.InventoryEnterpriseComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Inventory enterprise' },
        },
        {
            path: 'inventory-status',
            loadComponent: () =>
                import('./inventory-status/inventory-status.component').then((m) => m.InventoryStatusComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Inventory status' },
        },
        {
            path: 'sim-inventory',
            loadComponent: () => import('./siminventory/siminventory.component').then((m) => m.SiminventoryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Sim inventory' },
        },
        {
            path: 'sim-provider',
            loadComponent: () => import('./simprovider/simprovider.component').then((m) => m.SimproviderComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Sim provider' },
        },
        {
            path: 'telemetry-request',
            loadComponent: () =>
                import('./telemetry-request/telemetry-request.component').then((m) => m.TelemetryRequestComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Telemetry Request' },
        },
        {
            path: 'telemetry-response',
            loadComponent: () =>
                import('./telemetry-response/telemetry-response.component').then((m) => m.TelemetryResponseComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Telemetry Response' },
        },
        {
            path: 'telemetry-template-query',
            loadComponent: () =>
                import('./telemetry-template-query/telemetry-template-query.component').then(
                    (m) => m.TelemetryTemplateQueryComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Telemetry Template Query' },
        },
        {
            path: 'advanced-telemetry-reports',
            loadComponent: () =>
                import('./advanced-telemetry-reports/advanced-telemetry-reports.component').then(
                    (m) => m.AdvancedTelemetryReportsComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Advanced Telemetry Reports' },
        },
        {
            path: 'configuration-commands',
            loadComponent: () =>
                import('./inventory-configuration-commands/inventory-configuration-commands.component').then(
                    (m) => m.InventoryConfigurationCommandsComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Configuration Commands' },
        },
        {
            path: 'iot-telemetry-failure-logs',
            loadComponent: () =>
                import('./iot-telemetry-failure-logs/iot-telemetry-failure-logs.component').then(
                    (m) => m.IoTTelemetryFailureLogsComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'iot-telemetry-failure-logs' },
        },
    ],
};
